import { forwardRef } from "react";
import { TextInput } from "../inputs";
import { jsx } from "react/jsx-runtime";
const AccountPasswordInput = forwardRef(
  ({
    analyticsName,
    supportText = "5-128 characters",
    customValidator,
    validationErrorText,
    title = "Password",
    size = "medium",
    required = !0,
    ariaLabelledBy,
    ...props
  }, ref) => /* @__PURE__ */ jsx(
    TextInput,
    {
      ref,
      id: "password",
      analyticsName: `${analyticsName}-password`,
      size,
      required,
      textContentType: "password",
      supportText,
      ...ariaLabelledBy ? { ariaLabelledBy } : { title },
      ...props
    }
  )
);
AccountPasswordInput.displayName = "AccountPasswordInput";
export {
  AccountPasswordInput
};
